var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"praise cursor",class:{ 'whl-hand-up': _vm.type === 3},on:{"click":_vm.clickAnim}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide && _vm.type!=3),expression:"hide && type!=3"}],attrs:{"src":"/static/lottie/praise/images/point.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246e2922","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/video/praise.vue
// module id = null
// module chunks = 